import './App.css';
import SchedulingWidget from './Scheduling-widget';

function App() {
  return (
    <div className="App">
      <div className="header">
      <h1>Schedule a Service</h1>
      </div>
      <SchedulingWidget />
    </div>
  );
}

export default App;
